import { z } from "zod";

export const addressSchema = z.object({
  line1: z.string().optional(),
  subpremise: z.string().optional(),
  streetNumber: z.string().optional(),
  streetName: z.string().optional(),
  region: z.string().optional(),
  city: z.string(),
  metropolitanStatisticalArea: z.string().optional(),
  manualMsa: z.boolean().optional(),
  isApproximateMsa: z.boolean().optional(),
  combinedStatisticalArea: z.string().optional(),
  state: z.string(),
  country: z.string(),
  stateCode: z.string(),
  countryCode: z.string(),
  postalCode: z.string(),
  formatted: z.string(),
});
export type Address = z.infer<typeof addressSchema>;
